import Loader from 'components/Kizen/Loader';
import { AREA_RESPONSES } from 'components/Wizards/RTDV/types';
import { isPluginContentDashlet } from 'components/DashboardGrid/hooks/usePluginContentBlock';
import { isCustomCodeDashlet } from 'components/DashboardGrid/hooks/customCodeBlock';
import ResettableDashlet from 'pages/Dashboard/components/Dashlet/Resettable';
import { useHTMLConfig } from 'pages/Homepages/hooks/useHTMLConfig';
import { useModelQuery } from 'queries/models/custom-objects';
import { useMemo } from 'react';

const getObjectClass = (url) =>
  ['pipeline', 'standard'].includes(url) ? 'customObjects' : 'contacts';

export const IntermediateDashlet = ({
  dashlet,
  currentHomepage,
  setContentHeight,
  index,
  ...rest
}) => {
  const { data: model, isLoading } = useModelQuery(
    dashlet?.customObject,
    Boolean(dashlet?.customObject)
  );

  const builtModel = useMemo(() => {
    return model
      ? {
          ...model,
          objectClass: getObjectClass(model?.fetchUrl),
        }
      : {};
  }, [model]);

  const { builderContent } = useHTMLConfig(dashlet);

  const isCharts = Object.values(AREA_RESPONSES).includes(
    dashlet?.config?.reportType
  );

  const isPluginBlock = isPluginContentDashlet(dashlet);
  const isCustomCode = isCustomCodeDashlet(dashlet);

  if (isLoading) {
    return <Loader loading />;
  }

  return (
    <>
      <ResettableDashlet
        currentDashboard={currentHomepage}
        dashboardId={currentHomepage.id}
        dashlet={dashlet}
        model={builtModel}
        charts={isCharts}
        modalExtraProps={{
          homepage: true,
        }}
        objectForCharts={builtModel}
        homepages
        showDateShortcut={
          !isCharts && !builderContent && !isPluginBlock && !isCustomCode
        }
        setContentHeight={setContentHeight}
        index={index}
        builderContent={builderContent}
        {...rest}
      />
    </>
  );
};
